import { forwardRef, SelectHTMLAttributes } from "react";

interface Options {
    value: string | number;
    label: string;
}

interface FormSelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
    label: string;
    options: Options[];
    placeholder?: string;
}

export const FormSelect = forwardRef<HTMLSelectElement, FormSelectProps>(({ label, options, placeholder, ...props }, ref) => {
    return (
        <div>
            <label className="text-sm font-semibold">{label}</label>
            <select
                ref={ref}
                className="
                    w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2
                    font-semibold text-gray-600 text-sm"
                {...props} >
                {placeholder && (
                <option value={0} hidden>{placeholder}</option>
                )}

                {options.map((item) => (
                <option value={item.value} key={item.value}>{item.label}</option>
                ))}
            </select>
        </div>
    );
});

FormSelect.displayName = 'FormSelect';

interface InlineFormSelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
    label: string;
    options: Options[];
    icon?: React.ReactNode;
    labelWidth?: number;
    placeholder?: string;
}

export const InlineFormSelect = forwardRef<HTMLSelectElement, InlineFormSelectProps>(({ label, options, icon, labelWidth = 154, placeholder, ...props }, ref) => {
    return (
        <div className="flex items-center gap-x-2 w-full">
            <div className="flex items-center  gap-x-1">
                {icon}
                <label
                    style={{ minWidth: labelWidth }}
                    className="font-semibold min-w-[150px]">Estado</label>
            </div>

            <select
                {...props}
                ref={ref}
                className="
                    rounded-[3px] border-gray-400 border my-1 px-2
                    font-semibold text-gray-600 text-sm w-full h-[22px]">

                {placeholder && (
                <option hidden>{placeholder}</option>
                )}

                {options.map((item) => (
                    <option key={item.value} value={item.value}>{item.label}</option>
                ))}
            </select>
        </div>
    );
});

InlineFormSelect.displayName = "InlineFormSelect";
